import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { RaffleLot } from './raffle-lot'
import { RaffleLotSerializer } from './raffle-lot.serializer'

@Injectable()
export class RaffleLotService extends ResourceService<RaffleLot> {
  constructor(
    public http: HttpClient,
    raffleLotSerializer: RaffleLotSerializer
  ) {
    super(http, `${environment.backendApiUrl}/raffle-lots`, raffleLotSerializer)
  }
}
